


























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api/api';
import UnitModel from '@/models/status/unitmodel';
import MiniCharacterList from '@/components/parts/MiniCharacterList.vue';
import SimpleCharacterList from '@/components/parts/SimpleCharacterList.vue';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import UnitPicker from '@/components/parts/UnitPicker.vue';
import * as def from '@/common/definitions';
import Enumerable from 'linq';

@Component({
  components: {
    MiniCharacterList,
    SimpleCharacterList,
    CharacterIcon,
    UnitPicker,
  },
})
export default class UnitListView extends Vue {
  @Prop() private model!: UnitModel;
  @Prop() private isShow!: boolean;
  private isShowUnitLeaderOperations: boolean = false;
  private mode: number = 0;
  private changeLeaderTarget: api.Character = new api.Character(-1);

  private get selectedUnit(): api.Unit | undefined {
    return Enumerable.from(this.model.units).firstOrDefault((u) => u.isSelected);
  }

  @Watch('isShow')
  private updateIsShow() {
    // 表示状態を初期化
    this.mode = 0;
    this.model.updateUnits();
  }

  @Watch('model.leaderUnit')
  private updateLeaderUnit() {
    this.mode = 0;
  }
}
